
<template>
  <div>
    <el-form>
      <el-form-item>
        标题：<el-input type="text" placeholder="请输入标题" v-model="te_title" style="width:400px;"></el-input>
        </el-form-item>
          <el-form-item>
    <el-card style="height: 600px;">
      内容：<quill-editor v-model="te_text" ref="myQuillEditor" style="height: 500px;" :options="editorOption">
      </quill-editor>
    </el-card>
            </el-form-item>
      <el-form-item>
    状态:
        <label v-for="(item, index) in stateData" :key="index">
          <input
            type="radio"
            v-model="state"
            :value="item.value"
            @change="getStateVal"
          />
          {{ item.value }}
        </label>
        </el-form-item>
      <el-form-item>
      <el-button @click="save()">保存</el-button>
      <el-button @click="back()">返回</el-button>
        </el-form-item>
    </el-form>
  </div>

</template>

<script>
  import {
    quillEditor
  } from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  export default {
    inject:['reload'],
    name: 'FuncFormsEdit',
    components: {
      quillEditor
    },
    data() {
      return {
        stateData: [
          { value: '启用' },
          { value: '禁用' }
        ],
        state:'启用',
        te_state:0,
        te_title:'',
        te_text:'',
        editorOption: {}
      }
    },
    mounted() {
      console.log('错误')
    },
    methods:{
      getStateVal(){
        if(this.state == '启用'){
          this.te_state = 0
        }else if(this.state == '禁用'){
          this.te_state = 1
        }
      },
      save(){
        console.log("添加")
        this.$inbound.post({
          interfaceId: 'course/insertCourse',
          data:{
            te_state:this.te_state,
            te_title:this.te_title,
            te_text:this.te_text,
          }
        }).then(response => {
          this.$router.replace({path:'/Course'})
        }).catch(error => {
          console.log(error)
        })
      },
      back(){
        this.$router.replace({path:'/Course'})
      }
    }
  }

</script>

<style scoped>
</style>
